export const PERIOD_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'this_week', label: 'This Week' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'this_financial_year', label: 'This Financial Year' },
  { value: 'last_financial_year', label: 'Last Financial Year' },
  { value: 'all_time', label: 'All Time' },
  { value: 'custom', label: 'Custom' },
];

const fmt = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/**
 * Australian financial year: 1 Jul – 30 Jun.
 * Returns the FY start year for a given date.
 */
export const fyStartYear = (date) =>
  date.getMonth() >= 6 ? date.getFullYear() : date.getFullYear() - 1;

/**
 * Compute { from, to } date strings (YYYY-MM-DD) for the given period.
 * Weeks start on Monday.
 */
export const getDateRange = (period) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  switch (period) {
    case 'today':
      return { from: fmt(today), to: fmt(today) };

    case 'yesterday': {
      const d = new Date(today);
      d.setDate(d.getDate() - 1);
      return { from: fmt(d), to: fmt(d) };
    }

    case 'this_week': {
      const d = new Date(today);
      const day = d.getDay();
      d.setDate(d.getDate() - (day === 0 ? 6 : day - 1));
      return { from: fmt(d), to: fmt(today) };
    }

    case 'last_week': {
      const startOfThis = new Date(today);
      const day = startOfThis.getDay();
      startOfThis.setDate(startOfThis.getDate() - (day === 0 ? 6 : day - 1));
      const start = new Date(startOfThis);
      start.setDate(start.getDate() - 7);
      const end = new Date(startOfThis);
      end.setDate(end.getDate() - 1);
      return { from: fmt(start), to: fmt(end) };
    }

    case 'this_month':
      return {
        from: fmt(new Date(today.getFullYear(), today.getMonth(), 1)),
        to: fmt(today),
      };

    case 'last_month': {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth(), 0);
      return { from: fmt(start), to: fmt(end) };
    }

    case 'last_3_months':
      return {
        from: fmt(new Date(today.getFullYear(), today.getMonth() - 3, 1)),
        to: fmt(today),
      };

    case 'this_financial_year': {
      const y = fyStartYear(today);
      return { from: fmt(new Date(y, 6, 1)), to: fmt(today) };
    }

    case 'last_financial_year': {
      const y = fyStartYear(today) - 1;
      return { from: fmt(new Date(y, 6, 1)), to: fmt(new Date(y + 1, 5, 30)) };
    }

    case 'all_time':
    default:
      return { from: '', to: '' };
  }
};
